<template>
	<div>
		<div style="display: flex;justify-content: space-between;">
			<div style="width: 400px" class="yl-flex flex_between">
				<Input placeholder="请输入姓名..." v-model="searchFilter.talentName" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
                <Button class='ivu-btn-circle' type="primary" @click="searchTalent" style="margin-left: 10px;">搜索</Button>
				<Button class='ivu-btn-circle' type="primary" @click="resetClick" style="margin-left: 10px;">重置</Button>
			</div>
			<Button class='ivu-btn-circle' type="primary" @click="newClick">新增</Button>
		</div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="searchFilter.dateType">
                <Radio label="1"><span>今日</span></Radio>
                <Radio label="2"><span>昨日</span></Radio>
                <Radio label="3"><span>本周</span></Radio>
                <Radio label="4"><span>上周</span></Radio>
                <Radio label="5"><span>本月</span></Radio>
                <Radio label="6"><span>上月</span></Radio>
                <Radio label="7"><span>自定义</span></Radio>
                <DatePicker :value="searchFilter.timePeriodDate" @on-change="(e) => {searchFilter.timePeriodDate = e}" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">状态</div>
			<CheckboxGroup v-model="searchFilter.status">
				<Checkbox label="-1">待面试</Checkbox>
				<Checkbox label="1">通过</Checkbox>
				<Checkbox label="0">不通过</Checkbox>
				<Checkbox label="2">不参加</Checkbox>
			</CheckboxGroup>
		</div>
		<div class="multiple">
			<div class="child-div">阶段</div>
			<CheckboxGroup v-model="searchFilter.stage">
				<Checkbox label="first_filtrate">初筛</Checkbox>
				<Checkbox label="first_interview">一面</Checkbox>
				<Checkbox label="second_interview">二面</Checkbox>
			</CheckboxGroup>
		</div>
		<div class="multiple">
			<div class="child-div">通过司考</div>
			<RadioGroup v-model="searchFilter.nbeStatus">
				<Radio label="-1"><span>不限</span></Radio>
				<Radio label="1"><span>是</span></Radio>
				<Radio label="0"><span>否</span></Radio>
			</RadioGroup>
		</div>

		<div style="margin-top: 30px;">
			<Table size="small" :columns="columns" :data="talentInfo" @on-row-click="showTalentDetal"></Table>
		</div>
	</div>
</template>

<script>
    
    import {mapGetters} from 'vuex';
    
    import {
        getTalentSearchResult
        }from '@/api/talent.js';
	export default {
		name: "FirstFiltrate",

        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
		data() {
			return {
                searchFilter:{
                    talentName:'',
                    dateType: '', //时间区间
                    timePeriodDate:'', 
                    status:[],//状态
                    stage:[],//阶段
                    nbeStatus:'-1'
                },
                
                name:'',
				passExam: '',
				columns: [{
						title: '姓名111',
						key: 'talent_name',
					},
					{
						title: '性别',
						key: 'sex',
						filters: [{
								label: '男',
								value: '男'
							},
							{
								label: '女',
								value: '女'
							},
						],
						filterMultiple: false,
						filterMethod(value, row) {
                            return row.sex == value;
						}
					},
					{
                        title:'电话',
						key:'phone',
                        width:120
					},
					{
						title: '应聘岗位',
						key: 'position_name',
						filters: this.positionFilter,
						filterMultiple: false,
						filterMethod(value, row) {
                            return row.position_name == value;
						}
					},
					{
						title:'毕业院校',
						key:'school'
					},
					{
						title:'毕业时间',
						key:'graduateTime'
					},
					{
						title:'申请时间',
						key:'applyTime'
					},
					{
						title:'学历',
						key:'education',
						filters: [
                            {
                                label:'大专',
                                value:'大专'
                            },
                            {
                                label:'本科',
                                value:'本科'
                            },
                            {
                                label:'研究生',
                                value:'研究生'
                            },
                            {
                                label:'博士生',
                                value:'博士生'
                            },
						],
						filterMultiple: false,
						filterMethod(value, row) {
                            if(row.educationBackground.indexOf(value) != -1){
                                return row;
                            }
						}
					},
					{
						title:'面试官',
						key:'interviewer'
					},
					{
						title:'意见',
						key:'feedback'
					},
					{
						title:'阶段',
						key:'stage'
					},
					{
						title:'状态',
						key:'status'
					},
				]

			}
		},
        props:['talentInfo','positionFilter'],
		methods: {
            //搜索人才信息
            searchTalent(){
                let that = this
                let data = {token:that.token, searchFilter:that.searchFilter}
                
                getTalentSearchResult(data).then(function (res){
                       that.talentInfo = res.data.data
                });
            },
			// 重置
			resetClick() {
                this.searchFilter.talentName = '';
                this.searchFilter.dateType = '';
                this.searchFilter.timePeriodDate = '';
                this.searchFilter.status = [];
                this.searchFilter.stage = [];
                this.searchFilter.nbeStatus = '-1';
			},
            //显示人才详情
            showTalentDetal(index){
                let talentId = index.talentId
                if(talentId){
                    window.open('#/newtalents?id=' + talentId)
                }else{
                    this.$Message.warning('获取失败');
                }
            },
			// 新增
			newClick() {
                window.open('#/newtalents')
			}
		}
	}
</script>

<style scoped lang="less">
	.yl-flex {
		display: flex;
		width: 300px;
		justify-content: space-between;
	}

	.multiple {
		display: flex;
		margin: 10px 0;
	}

	.child-div {
		text-align-last: justify;
		width: 70px;
		margin-right: 10px;
		color: #C1C1C2;
	}
</style>
